module.exports = __webpack_public_path__ + "img/nocturna-h.87c2bd32.png";